import { createContext, useContext, useState, ReactNode } from "react";
import ConsultationModal from "@/components/ConsultationModal";

interface ConsultationModalContextType {
  openConsultation: () => void;
  closeConsultation: () => void;
}

const ConsultationModalContext = createContext<ConsultationModalContextType>({
  openConsultation: () => {},
  closeConsultation: () => {},
});

export function ConsultationModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ConsultationModalContext.Provider
      value={{
        openConsultation: () => setIsOpen(true),
        closeConsultation: () => setIsOpen(false),
      }}
    >
      {children}
      <ConsultationModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </ConsultationModalContext.Provider>
  );
}

export function useConsultation() {
  return useContext(ConsultationModalContext);
}
